"use client";

import { c as _c } from "react/compiler-runtime";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import React, { useState } from "react";
import { CookieConsentProvider, useCookieConsentController } from "#/features/cookieConsent/context/CookieConsentContext";
import { CookieConsentBannerWithDismissEffect } from "#/features/cookieConsent/ui/CookieConsentBannerWithDismissEffect";
import { useHasMounted } from "#/shared/hooks/useHasMounted";
type CookieConsentRootProps = {
  children: React.ReactNode;
};
export const CookieConsentRoot: React.FC<CookieConsentRootProps> = t0 => {
  const $ = _c(17);
  const {
    children
  } = t0;
  const hasMounted = useHasMounted();
  const consent = useCookieConsentController();
  const [isDismissAnimating, setIsDismissAnimating] = useState(false);
  const showConsentChrome = hasMounted;
  const showBanner = consent.showBanner || isDismissAnimating;
  let t1;
  if ($[0] !== consent.openCookieSettings) {
    t1 = {
      openCookieSettings: consent.openCookieSettings
    };
    $[0] = consent.openCookieSettings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== consent.acceptAll || $[3] !== consent.closeCookieSettings || $[4] !== consent.isSettingsView || $[5] !== consent.rejectNonEssential || $[6] !== showBanner || $[7] !== showConsentChrome) {
    t2 = showConsentChrome && showBanner ? <CookieConsentBannerWithDismissEffect isSettingsView={consent.isSettingsView} onAcceptAll={consent.acceptAll} onRejectNonEssential={consent.rejectNonEssential} onClose={consent.closeCookieSettings} onBeginDismiss={() => setIsDismissAnimating(true)} onCompleteDismiss={() => setIsDismissAnimating(false)} /> : null;
    $[2] = consent.acceptAll;
    $[3] = consent.closeCookieSettings;
    $[4] = consent.isSettingsView;
    $[5] = consent.rejectNonEssential;
    $[6] = showBanner;
    $[7] = showConsentChrome;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== consent.analyticsEnabled || $[10] !== showConsentChrome) {
    t3 = showConsentChrome && consent.analyticsEnabled ? <><Analytics /><SpeedInsights /></> : null;
    $[9] = consent.analyticsEnabled;
    $[10] = showConsentChrome;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <CookieConsentProvider value={t1}>{children}{t2}{t3}</CookieConsentProvider>;
    $[12] = children;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};